// ABOUTME: Top-of-chat strip shown on RESOLVED tickets (customer side).
// ABOUTME: Label on the left, green chip with the scheduled auto-close date on the right.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "../../../../components/theme/text/Text";
import { tokens } from "../../../../theme";
import { support_ticket_status } from "../../../../utils/staticEnums";

const AUTO_CLOSE_DAYS = 7;

const formatDate = (date, language) => {
    if (!date) return null;
    try {
        return date.toLocaleDateString(language || undefined, {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return date.toDateString();
    }
};

const ResolvedBanner = ({ ticket }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    if (!ticket || ticket.status !== support_ticket_status.RESOLVED) return null;

    const resolvedAt = ticket.resolvedAt ? new Date(ticket.resolvedAt) : null;
    const closesAt = resolvedAt
        ? new Date(resolvedAt.getTime() + AUTO_CLOSE_DAYS * 24 * 60 * 60 * 1000)
        : null;

    return (
        <Box sx={{ mx: 4, mt: 2 }}>
            <Box
                sx={{
                    height: 40,
                    borderRadius: 5,
                    background: `linear-gradient(to right, ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0]} -15%, ${colors.green[200]} 150%), ${theme.palette.mode === "dark" ? "black" : "white"}`,
                    border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                    pr: 0.5,
                    pl: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1.5,
                }}
            >
                <Text noBreak fontSize={13}>
                    {t("ticket_scheduled_to_close_on")}
                </Text>
                <Box
                    sx={{
                        flexShrink: 0,
                        height: 32,
                        px: 2,
                        borderRadius: 4,
                        background: colors.green[100],
                        lineHeight: "32px",
                    }}
                >
                    <Text bold variant="green">
                        {closesAt ? formatDate(closesAt, i18n.language) : t("not_set")}
                    </Text>
                </Box>
            </Box>
        </Box>
    );
};

export default ResolvedBanner;
